// import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
	root : {
		background   : 'linear-gradient(to right, #29A0BE, #3285AA)',
		color        : '#ffffff',
		borderRadius : '10px',
		'&:hover'    : {
			background : 'linear-gradient(to right, #78B7CB, #3285AA)'
		},
		'&$disabled' : {
			background : 'linear-gradient(to right, #78B7CB, #3E91AC)',
			color      : 'lightgrey',
			opacity    : '0.9'
		}
	},
	disabled : {}
});

const GradientButton = withStyles(styles)(Button);

export default GradientButton;
